import { Component, Input, OnChanges, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import * as Highcharts from 'highcharts';
import { SITE_ACTIVATION_STRATEGY } from 'src/constants/messages';

// high charts dependencies - FIXED: Using ES6 imports instead of require()
import Boost from 'highcharts/modules/boost';
import NoData from 'highcharts/modules/no-data-to-display';
import More from 'highcharts/highcharts-more';
import Exporting from 'highcharts/modules/exporting';
import Stock from 'highcharts/modules/stock';
import FullScreen from 'highcharts/modules/full-screen';

// Initialize Highcharts modules
Boost(Highcharts);
NoData(Highcharts);
More(Highcharts);
Exporting(Highcharts);
Stock(Highcharts);
FullScreen(Highcharts);

@Component({
    selector: 'app-expand-chart',
    templateUrl: './expand-chart.component.html',
    styleUrls: ['./expand-chart.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ExpandChartComponent implements OnInit, OnChanges {

  @Input() modal: NgbModalRef;
  @Input() modalRef: any;
  @Input() modalTitle: string;
  @Input() modalTitleSmall: string;
  @Input() parentScreen: string;
  @Input() chartOptions;
  @Input() legends: Array<any>;
  @Input() legendsHeader: string;
  highcharts: any;
  messageConstants = SITE_ACTIVATION_STRATEGY;
  chart: Highcharts.Chart; // Store chart reference
  
  // Map to store hidden plotLine configurations by legend name
  private hiddenPlotLines: Map<string, any[]> = new Map();

  chartCallback = (chart): void => {
    this.chart = chart; // Save chart reference
    setTimeout(() => {
      chart.redraw();
      chart.reflow();
    });
  }

  constructor() {
    this.highcharts = Highcharts;
  }

  ngOnInit(): void {
    //
  }

  ngOnChanges(): void {
    if (this.modalTitle && this.modalTitle.includes('Site Activation')) {
      (this as any).chartOptions.yAxis.title.text = null;
    } else {
      (this as any).chartOptions.chart.spacingLeft = 15;
    }
    (this as any).chartOptions.tooltip.snap = 1;
    // (this as any).chartOptions.chart.height = 457;
    // (this as any).chartOptions.chart.width = 870;
    // (this as any).chartOptions.chart.width = 1380;
  }

  modalDismissed(): void {
    this.modal.close();
  }
}